var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aia_header"}},[(_vm.theme == 'mass')?_c('MassHeader',{on:{"clickBack":_vm.clickBack}}):_vm._e(),(_vm.theme == 'prestige')?_c('PrestigeHeader',{on:{"clickBack":_vm.clickBack}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }